/**
 * Builds a new instance of the Accordion component.
 * @module Accordion
 * @constructor
 */

/** @lends module:Accordion */
function Accordion (scope, util, element, params) {
    var that = this;
    that.attribute = 'data-stry-accordion';

    /*  Catch instantiation errors  */
    if (!scope && !util && !element && !params) { return; }  //  Registration condition
    else {
        if (!scope) { console.error('StoryStream -> Accordion -> No scope provided.'); return; }
        if (!util) { console.error('StoryStream -> Accordion -> No util available.'); return; }
        if (!element) { console.error('StoryStream -> Accordion -> No element provided.'); return; }
        if (!params) { console.error('StoryStream -> Accordion -> No params provided.'); return; }
    }
    /*  End  */

    that.elem = element;
    that.nav_groups = {};
    that.uid = params.uid;


    /**
     * Funnel all events through this method and distribute.
     * @memberof Accordion
     * @function handleEvent
     * @param {object} e - Event data.
     * @inner
     */
    var handleEvent = function(e, params) {
        var type = e.type ? e.type : (e.html ? 'renderer' : false);
        switch(type) {
            case 'viewport.click':

                //  Listen for accordion related actions
                if (e.detail.action === 'accordion') {
                    var target = e.detail.e.target;
                    var parent = util.getClosest(target, function(el) {
               			return util.hasClass(el, 'menu-item');
            		});
                    var target_key = parent.getAttribute('data-stry-key');

                    //  If element key matches those in scope for this instance of the component
                    if (that.nav_groups[target_key]) {

                        //  Toggle component
                        util.toggleClass(that.nav_groups[target_key].elem, 'selected');
                    }
                }

                break;
        }
    };


    /**
     * Function used to reset Accordion groups.
     * @memberof Accordion
     * @function willResetNavGroups
     * @inner
     */
    var willResetNavGroups = function () {
        for (var item in that.nav_groups) {

            util.removeClass(that.nav_groups[item].elem, 'selected');
        }
    };


    /**
     * Function used construct functionality for Accordion.
     * @memberof Accordion
     * @function willConstructComponent
     * @inner
     */
    var willConstructComponent = function () {
        var menu = that.elem.getElementsByClassName('menu');

        //  Ensure menu element exists
        if (menu[0]) {
            var len = menu[0].children.length;
            var items = menu[0].children;
            var id_string;                  //  Unique sting for each menu element
            var key;                        //  Code key generated to identify elements and maintain scope
            var anchor;

            //  Loop through menu items and assigning functionality
            while (len--) {

                //  Only affect items with submenus
                if (items[len].getElementsByClassName('sub-menu')[0]) {

                    //  Gather unique string
                    id_string = items[len].className;

                    //  Generate key value
                    key = util.crc32_generate(id_string);

                    //  Add key to element
                    items[len].setAttribute('data-stry-key', key);

                    //  Define clickable anchor element
                    anchor = items[len].getElementsByTagName('a')[0];

                    //  Add accordion action attribute
                    anchor.setAttribute('data-stry-action', 'accordion');

                    //  Remove href attribute for parent items
                    anchor.removeAttribute('href');

                    //  Assign to isolated scope for future reference
                    that.nav_groups[key] = {
                        elem: items[len]
                    };
                }
            }
        }
    };


    /**
     * Function used to initialise the application.
     * @memberof Accordion
     * @function init
     * @inner
     */
    var init = function () {

        //  Setup component
        willConstructComponent();

        //  Listeners
        scope.addEventListener('viewport.click', handleEvent);
    };


    init();
    return that;
}
if (typeof module !== 'undefined' && exports !== null) {
    exports.Accordion = Accordion;
}
